import React from 'react';

export default function ArticlesNotFoundIcon({ color }) {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2279 10.0996C24.2279 10.0996 26.1515 11.3074 28.8372 11.3074C31.1599 11.3074 33.519 10.0996 33.519 10.0996M24.2279 10.0996C24.2279 10.0996 19.0536 11.8338 17.6588 12.7973C16.2641 13.7607 9.7832 22.3973 9.7832 22.3973L16.0982 28.5462L17.6588 27.0455V42.8569H40.0518V27.0455L41.6124 28.5462L48 22.3973C48 22.3973 41.1891 13.7783 40.0518 12.7973C38.9145 11.8163 33.519 10.0996 33.519 10.0996M24.2279 10.0996C24.2279 10.0996 23.7924 15.1474 28.8372 15.187C33.8819 15.2267 33.519 10.0996 33.519 10.0996"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M42.4609 48.3447L50.2772 57.5138"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M37.5553 50.1107C42.3418 50.1107 46.222 46.2305 46.222 41.444C46.222 36.6575 42.3418 32.7773 37.5553 32.7773C32.7689 32.7773 28.8887 36.6575 28.8887 41.444C28.8887 46.2305 32.7689 50.1107 37.5553 50.1107Z"
        fill="white"
        stroke={color}
        strokeWidth="1.2"
      />
      <rect
        x="34.9141"
        y="37.9561"
        width="8.66667"
        height="1.2"
        transform="rotate(45 34.9141 37.9561)"
        fill={color}
      />
      <rect
        x="34.0684"
        y="44.084"
        width="8.66667"
        height="1.2"
        transform="rotate(-45 34.0684 44.084)"
        fill={color}
      />
    </svg>
  );
}
